import axios from 'axios'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: 'http://123.207.30.115:19980',
    // 超时
    timeout: 10000
})


service.interceptors.request.use(config => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === true || (config.headers || {}).isToken === 'true'
    if (localStorage.getItem('User-Token') && isToken) {
        config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('User-Token') // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;

    if (code === 401) {
        if (localStorage.getItem('User-Token')) {
            location.reload();
        }
        localStorage.removeItem('User-Token');
    }

    return res;
}, error => {
    if (error.response.data.code === 401) {
        if (localStorage.getItem('User-Token')) {
            location.reload();
        }
        localStorage.removeItem('User-Token');
    }
    console.log(error)
    // Promise.reject(error)
})

export default service